import {useRef} from 'react'
import {useTranslation} from 'react-i18next'
import {RouteObject, redirect, useActionData, useNavigation} from 'react-router'
import {Form, Link} from 'react-router-dom'
import {Button} from '@UI/components/controls/Button/Button.tsx'
import {LogOut} from '@UI/components/icons/LogOut.tsx'
import {
    Body_12_Coral_Empasis_12,
    Body_14_Coral_Empasis_14,
    Body_16_Coral_Primary_Regular_16,
    Title_20_Coral_Primary_Regular_20,
    Title_28_Coral_Strong_emphasis_24
} from '@UI/typography/generated/typography.tsx'
import {Input} from '../../CommonComponents/Input/InputNative.tsx'
import {PasswordInput} from '../../CommonComponents/Input/PasswordInput.tsx'
import {Stack} from '../../CommonComponents/Stack/Stack.tsx'
import {ErrorPage} from '@src/Layers/ErrorLayer/ErrorPage.tsx'
import {logIn} from '../../Store/userStore.ts'
import {Gt} from '../../i18n/Gt.tsx'
import styles from './LoginPage.module.less'
import {CuteChickenPana} from "@UI/illustrationsSvg/CuteChickenPana.tsx";
import {UserPick} from "@UI/components/icons/UserPic.tsx";
import cn from "classnames";
import {Colors} from "@UI/theme/generated/Colors.ts";

interface ActionDataWithError {
    error?: { message: string, status: string }
}

export const LoginPage = () => {
    const ref = useRef<HTMLFormElement>(null)
    const actionData = useActionData<ActionDataWithError | undefined>()
    const navigation = useNavigation()
    const isSubmitting = navigation.state === 'submitting'
    const {t} = useTranslation()

    return (
        <Stack alignItems={'center'} direction='column' gap={32} className={styles.root} justifyContent={"center"} grow>
            <CuteChickenPana/>
            <Stack direction='column' gap={8}>
                <Title_28_Coral_Strong_emphasis_24 style={{textAlign: 'center'}}>
                    <span className={styles.title}><Gt>Welcome!</Gt></span>
                </Title_28_Coral_Strong_emphasis_24>
                <Title_20_Coral_Primary_Regular_20 style={{textAlign: 'center'}}>
                    <Gt>Work smarter every day</Gt>
                </Title_20_Coral_Primary_Regular_20>
            </Stack>
            <Form ref={ref} method='post' className={styles.form}>
                <Stack grow direction='column' gap={32}>
                    <Stack grow direction='column' gap={14}>
                        <Stack gap={4} direction={"column"}>
                            <Body_12_Coral_Empasis_12>
                                <Gt>ID</Gt>
                            </Body_12_Coral_Empasis_12>
                            <Input
                                leftIcon={<UserPick color={actionData?.error && Colors.Coral_special_Error_red} />}
                                required
                                name='username'
                                type='text'
                                disabled={isSubmitting}
                                placeholder={t('Input ID')}
                                initialValue={import.meta.env.VITE_DEBUG_USERNAME}
                                className={cn({[styles.errorInput]: actionData?.error})}
                            />
                        </Stack>

                        <Stack gap={4} direction={"column"}>
                            <PasswordInput disabled={isSubmitting} hasError={Boolean(actionData?.error)}/>
                            {actionData?.error && !isSubmitting && (
                                <Body_14_Coral_Empasis_14 className={styles.errorMessage}>
                                    <Gt>Incorrect ID or password</Gt>
                                </Body_14_Coral_Empasis_14>
                            )}
                        </Stack>
                    </Stack>

                    <Button disabled={isSubmitting} HTTLType={'submit'} icon={<LogOut/>}>
                        <Gt>Get in</Gt>
                    </Button>

                    <Stack justifyContent={"center"}>
                        <Link to={'/forgot'} className={styles.forgotPassButton}>
                            <Body_16_Coral_Primary_Regular_16>
                                <Gt>Can't log in?</Gt>
                            </Body_16_Coral_Primary_Regular_16>
                        </Link>
                    </Stack>
                </Stack>
            </Form>
        </Stack>
    )
}

export const path = 'login'

export const loginPageRoute: RouteObject = {
    path,
    element: <LoginPage/>,
    errorElement: <ErrorPage header={false}/>,
    action: async ({request}) => {
        let formData = await request.formData()
        const username = formData.get('username')
        const password = formData.get('password')
        if (username && password) {
            try {
                await logIn(username.toString().trim(), password.toString().trim())
                return redirect(`/check-in/`)
            } catch (error) {
                // if (error instanceof AxiosError) {
                //     if (error.status === 428) {
                //         if ((error as AxiosError<ResponseErrorDTO>).response as ResponseErrorDTO) {
                //             useCredsLoacal.setState({
                //                 email: username.toString(),
                //                 tempPass: password.toString()
                //             })
                //             return redirect(initialSetPath)
                //         }
                //     }
                // }
                return {error}
            }
        }
    }
}
